import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React, { useCallback, useEffect } from 'react';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../../routes/types';
import { RequestModalShell } from '../ReportGeneratorRequestModal/shared/RequestModalShell';

import { DetailsModalContent } from './shared/DetailsModalContent';
import { DetailsModalFooter } from './shared/DetailsModalFooter';

export const ReportGeneratorDetailsModal: React.FC = () => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { params } =
    useRoute<RouteProp<SignedInRootStackParamList, 'ReportGeneratorDetailsModal'>>();

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const sliderWidth = useBreakpointValue({ base: 1, sm: 0.55, lg: 0.42 });
  const item = params?.item;

  useEffect(() => {
    if (!item) {
      goBack();
    }
  }, [goBack, item]);

  if (!item) {
    return null;
  }

  return (
    <RequestModalShell
      sliderWidth={sliderWidth ?? 1}
      modalInsideModal={false}
      onDismiss={goBack}
      selectedCategoryLabel=""
      headerDismissIcon="close"
      hideHeader
      footer={<DetailsModalFooter item={item} />}>
      <DetailsModalContent item={item} onDismiss={goBack} />
    </RequestModalShell>
  );
};
